<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <app-codemirror
            class="w-full h-auto border border-grey-dark"
            :options="cmOptions"
            :class="options"
            v-bind="$attrs"
            v-model="content"
            slot="input"
            @input="update()"
        />
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';

    import { codemirror } from 'vue-codemirror';
    import 'codemirror/lib/codemirror.css';

    // language
    import 'codemirror/mode/xml/xml.js';
    import 'codemirror/mode/javascript/javascript.js';
    import 'codemirror/mode/css/css.js';
    import 'codemirror/mode/sass/sass.js';
    import 'codemirror/mode/php/php.js';
    import 'codemirror/mode/markdown/markdown.js';
    import 'codemirror/mode/nginx/nginx.js';
    import 'codemirror/mode/shell/shell.js';
    import 'codemirror/mode/vue/vue.js';
    import 'codemirror/mode/yaml/yaml.js';

    // require active-line.js
    import'codemirror/addon/selection/active-line.js';
    // styleSelectedText
    import'codemirror/addon/selection/mark-selection.js';
    import'codemirror/addon/search/searchcursor.js';
    // hint
    import'codemirror/addon/hint/show-hint.js';
    import'codemirror/addon/hint/show-hint.css';
    import'codemirror/addon/hint/javascript-hint.js';
    import'codemirror/addon/selection/active-line.js';
    // highlightSelectionMatches
    import'codemirror/addon/scroll/annotatescrollbar.js';
    import'codemirror/addon/search/matchesonscrollbar.js';
    import'codemirror/addon/search/searchcursor.js';
    import'codemirror/addon/search/match-highlighter.js';
    // keyMap
    import'codemirror/mode/clike/clike.js';
    import'codemirror/addon/edit/matchbrackets.js';
    import'codemirror/addon/comment/comment.js';
    import'codemirror/addon/dialog/dialog.js';
    import'codemirror/addon/dialog/dialog.css';
    import'codemirror/addon/search/searchcursor.js';
    import'codemirror/addon/search/search.js';
    import'codemirror/keymap/sublime.js';
    // foldGutter
    import'codemirror/addon/fold/foldgutter.css';
    import'codemirror/addon/fold/brace-fold.js';
    import'codemirror/addon/fold/comment-fold.js';
    import'codemirror/addon/fold/foldcode.js';
    import'codemirror/addon/fold/foldgutter.js';
    import'codemirror/addon/fold/indent-fold.js';
    import'codemirror/addon/fold/markdown-fold.js';
    import'codemirror/addon/fold/xml-fold.js';

    import'codemirror/addon/edit/closetag.js';

    export default {
        name: 'app-field-text',
        components: {
            'app-field': Field,
            'app-label': Label,
            'app-codemirror': codemirror
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            },
            mode: {
                type: String,
                default: 'text/javascript'
            }
        },
        data: () => ({
            content: '',
            cmOptions: {
                autoCloseTags: true,
                tabSize: 4,
                styleActiveLine: false,
                lineNumbers: true,
                styleSelectedText: false,
                line: true,
                foldGutter: true,
                gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
                highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
                mode: 'text/javascript',
                hintOptions:{
                    completeSingle: false
                },
                keyMap: "sublime",
                matchBrackets: true,
                showCursorWhenSelecting: true,
                extraKeys: { "Ctrl": "autocomplete" },
              }
        }),
        mounted() {
            if (this.mode) {
                this.cmOptions.mode = this.mode
            }

            if (this.value) {
                this.content = this.value;
            }

            setTimeout(() => {
                this.cmOptions.styleSelectedText =  true,
                this.cmOptions.styleActiveLine = true
            }, 1800)
        },
        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },
        methods: {
            update() {
                this.$emit('input', this.content)
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';

    .CodeMirror-focused .cm-matchhighlight {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAFklEQVQI12NgYGBgkKzc8x9CMDAwAAAmhwSbidEoSQAAAABJRU5ErkJggg==);
        background-position: bottom;
        background-repeat: repeat-x;
    }
    .cm-matchhighlight {background-color: lightgreen}
    .CodeMirror-selection-highlight-scrollbar {background-color: green}
    .CodeMirror {border:1px solid rgb(211,211,211); }

    .CodeMirror {height: 200px !important;}
    .cm-height-200 .CodeMirror {height: 200px !important;}
    .cm-height-500 .CodeMirror {height: 500px !important;}
</style>



// WEBPACK FOOTER //
// src/components/fields/inputs/Code.vue